<template>
  <div>
    <el-tooltip content="Add Rule" effect="dark" placement="top">
      <el-button class="fa fa-plus" id="addCampaignBtn" @click="createRuleDialogVisible = true" type="primary"></el-button>
    </el-tooltip>

    <rule-create 
      @close="createRuleDialogVisible=false"
      :visible="createRuleDialogVisible"
      :campaign="campaign">
    </rule-create>

    <rule-edit
      @close="editRuleDialogVisible=false"
      :rule="currentRule"
      :loading="loadingRule"
      :saving="updatingRule"
      :visible="editRuleDialogVisible"
      :campaign="campaign">
    </rule-edit>

    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Channel Rules</h5>
      </div>
      <div class="ibox-content">
        <el-table
          v-loading="loadingRules"
          ref="rulesTable"
          :data="rules"
          empty-text="No rules configured"
          style="width: 100%">
          <el-table-column
            label="Rule"
            prop="title">
          </el-table-column>
           <el-table-column>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import RuleCreate from '@/components/rules/RuleCreate';
import RuleEdit from '@/components/rules/RuleEdit';
import { mapState } from 'vuex';

export default {
  name: 'RuleList',
  components: { RuleCreate, RuleEdit },
  data: () => ({
    dialogTitle: null,
    createRuleDialogVisible: false,
    editRuleDialogVisible: false,
  }),
  props: {
    rules: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('rules', ['currentRule', 'loadingRules', 'updatingRule', 'loadingRule']),
    campaign() {
      return this.$route.params.campaignId;
    },
  },
  methods: {
    handleEdit(index, row) {
      this.$store.dispatch('rules/getRule', row.id);
      this.editRuleDialogVisible = true;
    },
    handleDelete(ruleIndex, rule) {
      this.$confirm(`Are you sure you want to delete rule: ${rule.title}?`).then(() => {
        this.$store.dispatch('rules/deleteRule', { ruleIndex, rule });
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/style/_variables_live.scss';

#addCampaignBtn {
  background-color: $amaranth;
  border-color: $amaranth;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  position: fixed;
  bottom: 55px;
  right: 20px;
  padding: 5px;
  font-size: 20px;

  .fa {
    margin: auto;
  }

  &:hover {
    background: $french-rose;
  }
}
</style>



// WEBPACK FOOTER //
// RulesList.vue?9ce169fc